(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["daylo-demo"] && !Shopify.designMode) return;
  try {
    
(()=>{
  function pack(p,hero=false){const lines=p.pack.map((s,i)=>`<text x="120" y="${206+i*17}" text-anchor="middle" font-family="Arial,sans-serif" font-size="${s.length>14?10:12}" font-weight="600" letter-spacing="1.1" fill="${p.tone}">${s}</text>`).join('');return `<svg viewBox="0 0 240 355" role="img" aria-label="${p.bottle_label}"><defs><linearGradient id="body-${p.id}-${hero?'hero':'card'}" x1="0" x2="1"><stop stop-color="#e5dfd2"/><stop offset=".23" stop-color="#fffaf0"/><stop offset=".75" stop-color="#f9f4e9"/><stop offset="1" stop-color="#d8d4c8"/></linearGradient><linearGradient id="cap-${p.id}-${hero?'hero':'card'}" x1="0" x2="1"><stop stop-color="#163a29"/><stop offset=".4" stop-color="${p.tone}"/><stop offset="1" stop-color="#163a29"/></linearGradient></defs><ellipse cx="122" cy="334" rx="89" ry="11" fill="#1f4a33" opacity=".13"/><rect x="37" y="58" width="166" height="275" rx="28" fill="url(#body-${p.id}-${hero?'hero':'card'})" stroke="#b1b7a4" stroke-width=".7"/><rect x="42" y="22" width="156" height="51" rx="7" fill="url(#cap-${p.id}-${hero?'hero':'card'})"/>${Array.from({length:25},(_,i)=>`<path d="M${48+i*6} 29v34" stroke="#a5b197" stroke-opacity=".22" stroke-width="1"/>`).join('')}<path d="M52 76h137" stroke="#d2d8c4"/><rect x="37" y="111" width="166" height="159" fill="#f4f1e7"/><path d="M37 111h166M37 270h166" stroke="#dfdfcf" stroke-width=".7"/><text x="120" y="160" text-anchor="middle" font-family="Arial,sans-serif" font-size="35" font-weight="800" letter-spacing="-2" fill="${p.tone}">DAYLO</text><path d="M61 181h118" stroke="${p.tone}" stroke-width=".6"/>${lines}<text x="120" y="251" text-anchor="middle" font-family="Arial,sans-serif" font-size="6.3" letter-spacing="1" fill="#68745d">${p.pack_caption}</text><path d="M54 304c27 11 112 13 131-1" fill="none" stroke="#fffdf3" stroke-width="3" opacity=".45"/></svg>`}
  function initialize(root){
    if(root.dataset.dayloInitialized)return;root.dataset.dayloInitialized='true';
    const localized=JSON.parse(root.querySelector('[data-daylo-translations]').textContent),products=localized.products,guides=localized.guides,ui=localized.ui;
    const grid=root.querySelector('[data-product-grid]');if(!grid)return;
    grid.innerHTML=products.map((p,i)=>`<article class="product-card" data-category="${p.category}" style="--card-bg:${p.bg}"><button type="button" class="product-art-button" data-product="${p.id}" aria-label="${p.explore_label}"><div class="product-art"><span class="product-index">DAYLO / 0${i+1}</span>${pack(p)}<span class="product-arrow" aria-hidden="true">↗</span></div></button><div class="product-copy"><p>${p.type}</p><h3>${p.name}</h3><button type="button" class="product-detail-button" data-product="${p.id}">${ui.explore_details} <span aria-hidden="true">→</span></button></div></article>`).join('');
    root.querySelectorAll('[data-pack]').forEach(el=>el.innerHTML=pack(products.find(p=>p.id===el.dataset.pack),true));
    const dialog=root.querySelector('[data-detail-dialog]'),content=root.querySelector('[data-dialog-content]');let lastFocus=null;
    function open(html){lastFocus=document.activeElement;content.innerHTML=html;dialog.showModal();dialog.querySelector('.dialog-close').focus()}
    function close(){dialog.close();lastFocus?.focus()}
    root.querySelector('.dialog-close').addEventListener('click',close);
    dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close()}});
    dialog.addEventListener('cancel',()=>{setTimeout(()=>lastFocus?.focus(),0)});
    root.addEventListener('click',e=>{
      const pbutton=e.target.closest('[data-product]');if(pbutton){const p=products.find(p=>p.id===pbutton.dataset.product);open(`<div class="dialog-product"><div class="dialog-art" style="--card-bg:${p.bg}">${pack(p)}</div><div class="dialog-copy"><p class="eyebrow">${ui.planned_collection}</p><h2 id="detail-title">${p.name}</h2><p>${p.description}</p><ul class="detail-list"><li><span>${ui.formula}</span><span>${ui.finalizing}</span></li><li><span>${ui.serving}</span><span>${ui.finalizing}</span></li><li><span>${ui.label}</span><span>${ui.verifying}</span></li><li><span>${ui.price}</span><span>${ui.before_launch}</span></li></ul><p class="dialog-note">${ui.preview_note}<br>${ui.ordering_note}</p></div></div>`);return}
      const gbutton=e.target.closest('[data-guide]');if(gbutton){const g=guides[gbutton.dataset.guide];open(`<div class="dialog-guide"><p class="eyebrow">${ui.approach}</p><h2 id="detail-title">${g.title}</h2><p>${g.copy}</p>${g.items?`<ul>${g.items.map(x=>`<li>${x}</li>`).join('')}</ul>`:''}${g.email?`<a class="button button-primary" href="mailto:${g.email}">${ui.email} <span aria-hidden="true">↗</span></a>`:''}</div>`);return}
      const filter=e.target.closest('[data-filter]');if(filter){root.querySelectorAll('[data-filter]').forEach(b=>{const selected=b===filter;b.classList.toggle('active',selected);b.setAttribute('aria-pressed',selected)});let n=0;grid.querySelectorAll('[data-category]').forEach(card=>{card.hidden=filter.dataset.filter!=='all'&&card.dataset.category!==filter.dataset.filter;if(!card.hidden)n++});root.querySelector('.range-count').textContent=(n===1?ui.result_singular:ui.result_plural).replace('__COUNT__',String(n));return}
      const anchor=e.target.closest('.main-nav a');if(anchor){root.querySelector('.main-nav').classList.remove('open');root.querySelector('.menu-toggle').setAttribute('aria-expanded','false')}
    });
    const menu=root.querySelector('.menu-toggle');menu.addEventListener('click',()=>{const open=menu.getAttribute('aria-expanded')!=='true';menu.setAttribute('aria-expanded',open);root.querySelector('.main-nav').classList.toggle('open',open)});
  }
  document.querySelectorAll('[data-daylo-demo]').forEach(initialize);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-daylo-demo]').forEach(initialize));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daylo-header"]) return;
  try {
    
(() => {
  const controllers = new WeakMap();
  function initializeNavigation(scope = document) {
    const header = scope.id === 'daylo-header' ? scope : scope.querySelector('#daylo-header');
    if (!header || header.dataset.navigationReady === 'true') return;
    const toggle = header.querySelector('.d-menu-toggle');
    const navigation = header.querySelector('#daylo-navigation');
    if (!toggle || !navigation) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    controllers.set(header, controller);
    header.dataset.navigationReady = 'true';
    const mobile = window.matchMedia('(max-width: 760px)');

    function setOpen(open, returnFocus = false) {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
      navigation.classList.toggle('is-open', open);
      if (returnFocus) toggle.focus();
    }

    toggle.addEventListener('click', () => {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    }, options);
    navigation.addEventListener('click', (event) => {
      if (event.target.closest('a')) setOpen(false);
    }, options);
    header.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        event.preventDefault();
        setOpen(false, true);
      }
    }, options);
    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) setOpen(false);
    }, options);
    header.addEventListener('focusout', (event) => {
      if (event.relatedTarget && !header.contains(event.relatedTarget)) setOpen(false);
    }, options);
    mobile.addEventListener('change', () => setOpen(false), options);
  }

  initializeNavigation();
  document.addEventListener('shopify:section:load', event => initializeNavigation(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const header = event.target.querySelector('#daylo-header');
    if (!header) return;
    controllers.get(header)?.abort();
    controllers.delete(header);
    delete header.dataset.navigationReady;
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
